"use client"

import { useEffect } from "react"

import { initPartnerAgentCapture } from "@/lib/partners/agent-client"
import { initPartnerCapture } from "@/lib/partners/client"

export function PartnerBootstrap() {
  useEffect(() => {
    initPartnerCapture()
    initPartnerAgentCapture()
  }, [])

  return null
}
